import React from "react";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="21"
            viewBox="0 0 18 21"
            fill="none"
        >
            <g clip-path="url(#clip0_1568_64311)">
                <path
                    d="M17.2337 4.13979C17.7247 4.63086 17.7247 5.42836 17.2337 5.91943L7.17652 15.9766C6.68545 16.4676 5.88795 16.4676 5.39688 15.9766L0.368304 10.948C-0.122768 10.4569 -0.122768 9.65943 0.368304 9.16836C0.859375 8.67729 1.65688 8.67729 2.14795 9.16836L6.28866 13.3051L15.4579 4.13979C15.949 3.64872 16.7465 3.64872 17.2376 4.13979H17.2337Z"
                    fill="#333739"
                />
            </g>
            <defs>
                <clipPath id="clip0_1568_64311">
                    <rect width="17.6" height="20.1143" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
